import React, { useEffect, useRef, useState } from 'react';

export function Hello() {
  const [name, setName] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [feed, setFeed] = useState([]);
  const [unread, setUnread] = useState(0);

  const root = document.getElementById('react-root');
  const userData = root?.dataset?.user ? JSON.parse(root.dataset.user) : null;
  const pageTitle = root?.dataset?.page || 'Página';

  // Endpoints já existentes (sem criar novos controllers)
  const analystPath = root?.dataset?.assignmentsPath || '/legal_processes/new_assignments';
  const adminPath   = root?.dataset?.adminNotificationsPath || '/admin/legal_processes/notifications';

  const lastCheckRef = useRef(null);
  const pollingRef   = useRef(null);

  // roles helpers (suporta tanto 'role' único quanto array 'roles')
  const roles = Array.isArray(userData?.roles) ? userData.roles : [userData?.role].filter(Boolean);
  const isAnalyst = roles?.includes('analyst');
  const isAdmin   = roles?.includes('admin');
  const isSupport = roles?.includes('support');

  useEffect(() => { setName(userData?.name || ''); }, [userData]);

  // relógio
  useEffect(() => {
    const id = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // storage por usuário e escopo de feed
  const lcKey = (base) => `${base}:notifs:${userData?.id || 'anon'}`;
  const getSeen = () => {
    try { return new Set(JSON.parse(localStorage.getItem(lcKey('seenKeys')) || '[]')); }
    catch { return new Set(); }
  };
  const addSeen = (keys) => {
    const s = getSeen(); keys.forEach(k => s.add(k));
    localStorage.setItem(lcKey('seenKeys'), JSON.stringify(Array.from(s)));
  };

  // baseline do ponteiro "since" (por usuário)
  useEffect(() => {
    if (!lastCheckRef.current) {
      const nowIso = new Date().toISOString();
      lastCheckRef.current = localStorage.getItem(lcKey('lastCheckAt')) || nowIso;
      localStorage.setItem(lcKey('lastCheckAt'), lastCheckRef.current);
    }
  }, [userData]);

  // polling unificado por papéis
  // useEffect(() => {
  //   if (!userData?.id) return;

  //   // mapeia papéis -> endpoints permitidos (sem criar novos)
  //   const endpoints = [];
  //   if (isAnalyst) endpoints.push({ kind: 'analyst', url: analystPath });
  //   if (isAdmin || isSupport) endpoints.push({ kind: 'adminlike', url: adminPath });

  //   if (endpoints.length === 0) return;

  //   const INTERVAL_MS = 30000;

  //   const fetchOne = async (url, sinceIso) => {
  //     const res = await fetch(`${url}?since=${encodeURIComponent(sinceIso)}`, { headers: { Accept: 'application/json' }});
  //     if (!res.ok) return [];
  //     const json = await res.json();
  //     console.log(json)
  //     return Array.isArray(json.items) ? json.items : [];
  //   };

  //   const toKey = (it) => `${it.type}:${it.id}:${it.occurred_at}`;

  //   const tick = async () => {
  //     const since = lastCheckRef.current || new Date(Date.now() - 60000).toISOString();
  //     try {
  //       // busca em paralelo todos os feeds permitidos
  //       const all = await Promise.all(endpoints.map(e => fetchOne(e.url, since)));
  //       // flatten
  //       const items = all.flat();
  //       console.log(">>>>>", items)


  //       // dedupe por (type, id, occurred_at)
  //       const seen = getSeen();
  //       const merged = [];
  //       const keysToAdd = [];

  //       for (const it of items) {
  //         const k = toKey(it);
  //         if (seen.has(k)) continue;
  //         // valida mínimos
  //         if (!it?.type || !it?.occurred_at || typeof it?.id === 'undefined') continue;
  //         merged.push(it);
  //         keysToAdd.push(k);
  //       }

  //       if (merged.length > 0) {
  //         // ordena por data desc e limita feed
  //         merged.sort((a, b) => new Date(b.occurred_at) - new Date(a.occurred_at));
  //         // setFeed(prev => {
  //         //   const next = [...merged, ...prev];
  //         //   // dedupe adicional no estado (caso de re-fetch)
  //         //   const set2 = new Set();
  //         //   const uniq = [];
  //         //   for (const it of next) {
  //         //     const k = toKey(it);
  //         //     if (set2.has(k)) continue;
  //         //     set2.add(k);
  //         //     uniq.push(it);
  //         //     if (uniq.length >= 50) break; // limite de janela
  //         //   }
  //         //   return uniq;
  //         // });
  //         setFeed(prev => {
  //           console.log("🔥 FEED PREV:", prev);
  //           console.log("🔥 MERGED:", merged);

  //           const next = [...merged, ...prev];

  //           const set2 = new Set();
  //           const uniq = [];
  //           for (const it of next) {
  //             const k = toKey(it);
  //             if (set2.has(k)) continue;
  //             set2.add(k);
  //             uniq.push(it);
  //             if (uniq.length >= 50) break;
  //           }

  //           console.log("🔥 FEED NEXT:", uniq);
  //           return uniq;
  //         });
  //         setUnread(c => c + merged.length);
  //         addSeen(keysToAdd);
  //       }
  //     } catch (_) {
  //       // opcional: console.warn(_)
  //     } finally {
  //       const nowIso = new Date().toISOString();
  //       lastCheckRef.current = nowIso;
  //       localStorage.setItem(lcKey('lastCheckAt'), nowIso);
  //     }
  //   };

  //   console.log("===>", userData, analystPath, adminPath, isAnalyst, isAdmin, isSupport)
  //   console.log(">>", feed)


  //   tick();
  //   pollingRef.current = setInterval(tick, INTERVAL_MS);
  //   return () => { if (pollingRef.current) clearInterval(pollingRef.current); };
  // }, [userData?.id, analystPath, adminPath, isAnalyst, isAdmin, isSupport]);
  const toKey = (it) => `${it.type}:${it.id}:${it.occurred_at}`;


  useEffect(() => {
    if (!userData?.id) return;

    const endpoints = [];
    if (isAnalyst) endpoints.push({ kind: "analyst", url: analystPath });
    if (isAdmin || isSupport) endpoints.push({ kind: "adminlike", url: adminPath });
    if (endpoints.length === 0) return;

    console.log("🎯 POLLING EFFECT MONTADO");

    const INTERVAL_MS = 30000;
    let intervalId = null;

    const normalizeDate = (iso) => new Date(iso).getTime();
    const toKey = (it) => `${it.type}:${it.id}:${normalizeDate(it.occurred_at)}`;

    const fetchOne = async (url, sinceIso) => {
      const res = await fetch(`${url}?since=${encodeURIComponent(sinceIso)}`, {
        headers: { Accept: "application/json" }
      });

      if (!res.ok) return { items: [], since: sinceIso };

      const json = await res.json();
      console.log("🔥 RAW:", json);

      return {
        items: Array.isArray(json.items) ? json.items : [],
        since: json.since || sinceIso
      };
    };


    const tick = async () => {
      const since = lastCheckRef.current || new Date(Date.now() - 60000).toISOString();

      try {
        const results = await Promise.all(endpoints.map(e => fetchOne(e.url, since)));

        // const latestSince = results[0]?.since || since;
        const latestSince = results
                              .map(r => r.since)
                              .filter(Boolean)
                              .sort()
                              .pop() || since;

        const items = results.flatMap(r => r.items);
        console.log("🔥 ITEMS REAIS:", items);

        const seen = getSeen();
        const merged = [];
        const keysToAdd = [];

        for (const it of items) {
          console.log("🔍 PROCESSANDO ITEM:", it);

          if (!it?.type || !it?.occurred_at || typeof it?.id === "undefined") continue;

          const key = toKey(it);

          console.log("🔑 KEY:", key);
          console.log("👁 SEEN TEM ESSA KEY?:", seen.has(key));

          if (seen.has(key)) continue;

          merged.push(it);
          keysToAdd.push(key);
        }

        if (merged.length > 0) {
          merged.sort((a, b) => new Date(b.occurred_at) - new Date(a.occurred_at));

          setFeed(prev => {
            console.log("🔥 FEED PREV:", prev);

            const next = [...merged, ...prev];

            const uniq = [];
            const dedupe = new Set();
            for (const it of next) {
              const k = toKey(it);
              if (dedupe.has(k)) continue;

              dedupe.add(k);
              uniq.push(it);
              if (uniq.length >= 50) break;
            }

            console.log("🔥 FEED NEXT:", uniq);
            return uniq;
          });

          setUnread(c => c + merged.length);
          addSeen(keysToAdd);
        }

        lastCheckRef.current = latestSince;
        localStorage.setItem(lcKey("lastCheckAt"), latestSince);
      } catch (err) {
        console.error("🔥 POLLING ERROR:", err);
      }
    };

    tick();
    intervalId = setInterval(tick, INTERVAL_MS);

    return () => {
      console.log("🧹 POLLING EFFECT DESMONTADO");
      if (intervalId) clearInterval(intervalId);
    };
  }, [userData?.id, isAnalyst, isAdmin, isSupport, analystPath, adminPath]);


  const handleOpenNotifications = () => {
    const keys = feed.map(it => toKey(it));
    addSeen(keys);

    setUnread(0);
  };

  const greetings = () => {
    const h = currentTime.getHours();
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  const typeMeta = (t) => ({
    legal_process_created:  { label: 'Novo processo',       klass: 'bg-primary',            icon: 'bi-journal-plus' },
    legal_process_assigned: { label: 'Processo atribuído',  klass: 'bg-info text-dark',     icon: 'bi-person-check' },
    legal_process_updated:  { label: 'Processo atualizado', klass: 'bg-secondary',          icon: 'bi-pencil-square' },
    absence_created:        { label: 'Afastamento',         klass: 'bg-warning text-dark',  icon: 'bi-person-dash' },
    absence_ended:          { label: 'Afastamento fim',     klass: 'bg-success',            icon: 'bi-person-check-fill' },
    user_created:           { label: 'Usuário criado',      klass: 'bg-dark',               icon: 'bi-person-plus' },
    user_updated:           { label: 'Usuário atualizado',  klass: 'bg-dark-subtle',        icon: 'bi-person-gear' },
  }[t] || { label: 'Atualização', klass: 'bg-light text-dark', icon: 'bi-bell' });

  return (
    <div className="border-bottom border-success mb-3">
      <h3 className="fw-bold mb-0" style={{fontFamily: 'Roboto Condensed'}}>{pageTitle.toUpperCase()}</h3>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold fs-12" style={{fontFamily: 'Roboto Condensed'}}>
          {greetings()}, {name}!
        </h5>

        <div className="d-flex align-items-center gap-3">
          <h5 style={{fontFamily: 'Roboto Condensed'}}>{new Date().toLocaleString()}</h5>

          {/* sino / dropdown */}
          <div className="dropdown">
            <button
              className="btn btn-outline-secondary position-relative btn-sm"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Notificações"
              // onClick={() => setUnread(0)}
              // onClick={handleOpenNotifications}
            >
              <i className="fa-regular fa-bell"></i>
              {unread > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {unread}
                </span>
              )}
            </button>

            <ul className="dropdown-menu dropdown-menu-end p-0" style={{minWidth: 380}}>
              <li className="px-3 py-2 border-bottom fw-semibold small">Feed de notificações</li>
              {feed.length === 0 && <li className="px-3 py-3 text-muted small">Sem novidades</li>}

              {feed.map((it, idx) => {
                const meta = typeMeta(it.type);
                const when = new Date(it.occurred_at);
                return (
                  <li key={`${it.type}-${it.id}-${it.occurred_at}-${idx}`} className="px-3 py-2">
                    <div className="d-flex align-items-center gap-2">
                      <i className={`bi ${meta.icon}`}></i>
                      <span className={`badge ${meta.klass}`}>{meta.label}</span>
                    </div>

                    <div className="small mt-1">
                      {it.url
                        ? <a href={it.url} className="link-underline link-underline-opacity-0"><strong>{it.title}</strong></a>
                        : <strong>{it.title}</strong>}
                    </div>

                    {it.subtitle && <div className="text-muted small">{it.subtitle}</div>}
                    <div className="text-muted small">{when.toLocaleString()}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
